import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { theme as themeConfig, Row, Col } from "antd"

import { fetchLiveMetrics } from "../../../../../data/redux/campaign_analytics_details/actions"

import { IMG_ERROR } from "../../../../../data/assets"

import ShowMessage from "../../../../components/ShowMessage"

import MetricsCard from "../components/Metrics/MetricsCard"
import MetricsTable from "../components/Metrics/MetricsTable"

import "../index.scss"

const LiveMetrics = ({
  metrics,
  tableData,
  actions,
  selectedCampaignIds,
  loadError,
}) => {
  const { token } = themeConfig.useToken()
  const { fetchLiveMetrics } = actions
  const [timeLeft, setTimeLeft] = useState(10)

  useEffect(() => {
    let intervalId = null
    let timeLeft = 10
    let pendingCall = false

    const tick = () => {
      timeLeft--
      setTimeLeft(timeLeft)

      if (timeLeft <= 0) {
        timeLeft = 10

        if (document.visibilityState === "visible") {
          fetchLiveMetrics({ campaignIds: selectedCampaignIds })
          pendingCall = false
        } else {
          pendingCall = true
        }
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        if (pendingCall) {
          fetchLiveMetrics({ campaignIds: selectedCampaignIds })
          pendingCall = false

          timeLeft = 10
          setTimeLeft(timeLeft)
        }
      }
    }

    intervalId = setInterval(tick, 1000)
    document.addEventListener("visibilitychange", handleVisibilityChange)

    if (document.visibilityState === "visible") {
      fetchLiveMetrics({ campaignIds: selectedCampaignIds })
    } else {
      pendingCall = true
    }

    return () => {
      clearInterval(intervalId)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [selectedCampaignIds, fetchLiveMetrics])

  const renderCardById = id => {
    const component = metrics?.find(item => item?.id === id)
    return component ? <MetricsCard item={component} /> : null
  }

  const renderTableById = id => {
    const component = tableData?.find(item => item?.id === id)
    return component ? <MetricsTable item={component} /> : null
  }

  return (
    <div
      style={{
        borderRadius: token.borderRadius,
        marginBottom: token.marginSM,
      }}
    >
      {loadError ? (
        <ShowMessage
          ImgComponent={IMG_ERROR}
          title="Error occurred"
          message="Something went wrong while loading the live metrics. Please reload the page."
          height={200}
          width={200}
        />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p
              style={{
                fontSize: token.fontSizeLG,
                fontWeight: token.fontWeightStrong,
                marginBottom: token.marginSM,
                marginLeft: token.marginXXS,
              }}
            >
              Live Stats
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: token.marginSM,
              }}
            >
              <span className="pulse-circle" />
              <span
                style={{
                  fontSize: token.fontSize,
                  fontWeight: token.fontWeightStrong,
                }}
              >
                {timeLeft}s
              </span>
            </div>
          </div>
          <Row gutter={[10, 10]}>
            {/* Metrics Cards */}
            <Col xs={24} sm={24} md={6}>
              <Row gutter={[12, 12]}>
                {["live_metrics_globalCallConnectivity"].map(id => (
                  <Col xs={24} key={id}>
                    {renderCardById(id)}
                  </Col>
                ))}
              </Row>
            </Col>
            {/* Table */}
            <Col xs={24} sm={24} md={18}>
              {renderTableById("live_metrics_campaignCallConnectivity")}
            </Col>
          </Row>
        </>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  metrics: state.campaigns_analytics_details.liveMetrics.metrics,
  tableData: state.campaigns_analytics_details.liveMetrics.tables,
  loadError: state.campaigns_analytics_details.lLoadError,
  selectedCampaignIds: state.campaigns_analytics_details.selectedCampaignIds,
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        fetchLiveMetrics,
      },
      dispatch
    ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveMetrics)
